module.exports = __webpack_public_path__ + "img/20220310_151020.d51322a5.jpg";